/**
 * Abertura automática do contato (modal de WhatsApp; na página de orçamento, o formulário) por
 * inatividade: 60s sem interação (clique, tecla, rolagem, mouse) depois que o visitante interagiu.
 * Acontece no máximo uma vez por sessão do navegador (cookie de sessão: vale para todas as abas e
 * volta a valer quando o navegador é fechado). Abrir pelo botão de WhatsApp não conta.
 */
(() => {
    "use strict";

    const SESSION_COOKIE = "site-contato-automatico";
    const IDLE_MS = 60000;
    const ACTIVITY_EVENTS = ["pointerdown", "pointermove", "keydown", "scroll", "wheel", "touchstart"];

    let idleTimer = 0;
    let lastActivity = 0;
    let listening = false;
    let userHasEngaged = false;

    function isAutomatedClient() {
        if (navigator.webdriver) {
            return true;
        }
        return /Chrome-Lighthouse|PageSpeed|HeadlessChrome/i.test(navigator.userAgent);
    }

    function alreadyShown() {
        return document.cookie.split("; ").includes(`${SESSION_COOKIE}=1`);
    }

    function markShown() {
        document.cookie = `${SESSION_COOKIE}=1; path=/; SameSite=Lax`;
    }

    function isBlocked() {
        if (document.querySelector("dialog[open]")) {
            return true;
        }
        if (document.querySelector(".cesta-orcamento-site.is-open, .mega-menu.is-open")) {
            return true;
        }
        const active = document.activeElement;
        return Boolean(active && active.closest("input, textarea, select, [contenteditable='true']"));
    }

    function orcamentoForm() {
        return document.querySelector(".form-orcamento-site, [data-orcamento-form], .page-orcamento-site .form-orcamento-frame");
    }

    function engageOrcamento(form) {
        markShown();
        form.classList.add("is-idle-ready");
        form.scrollIntoView({ behavior: "smooth", block: "center" });
        const field = form.querySelector("input:not([type='hidden']):not([disabled]), textarea:not([disabled]), select:not([disabled])");
        field?.focus({ preventScroll: true });
    }

    function engageWhatsapp() {
        const modal = document.querySelector(".modal-whatsapp-contact");
        if (!modal || typeof modal.showModal !== "function" || modal.open) {
            return;
        }
        markShown();
        modal.showModal();
    }

    function engage() {
        if (isAutomatedClient() || !userHasEngaged || alreadyShown() || isBlocked() || document.hidden) {
            return;
        }

        const form = orcamentoForm();
        if (form && document.body.classList.contains("page-orcamento-site")) {
            engageOrcamento(form);
            return;
        }

        engageWhatsapp();
    }

    function armIdle() {
        window.clearTimeout(idleTimer);
        if (isAutomatedClient() || !userHasEngaged || alreadyShown()) {
            return;
        }
        idleTimer = window.setTimeout(engage, IDLE_MS);
    }

    function noteActivity() {
        userHasEngaged = true;
        // pointermove/scroll disparam em rajada: reiniciar a contagem uma vez por segundo basta
        const now = Date.now();
        if (now - lastActivity < 1000) {
            return;
        }
        lastActivity = now;
        armIdle();
    }

    function bind() {
        if (isAutomatedClient() || listening) {
            return;
        }

        listening = true;
        ACTIVITY_EVENTS.forEach((type) => document.addEventListener(type, noteActivity, { passive: true }));
        // Aba em segundo plano não conta como inatividade: a contagem recomeça na volta
        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                window.clearTimeout(idleTimer);
                return;
            }
            armIdle();
        });
    }

    if (typeof window.siteReady === "function") {
        window.siteReady(bind);
        return;
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bind);
    } else {
        bind();
    }
})();
